// extracted by mini-css-extract-plugin
export var quantityInput = "_op-0";